export default {
  // Hero
  servicesHeroTag: "What We Offer",
  servicesHeroTitle1: "End-to-End Services",
  servicesHeroTitle2: "for East Africa",
  servicesHeroDesc: "From company registration to tender participation, AIP provides a comprehensive suite of services to support your business journey across East Africa.",
  pillRegistration: "Company Registration",
  pillCompliance: "Regulatory Compliance",
  pillInvestment: "Investment Facilitation",
  pillExpansion: "Business Expansion",
  pillTender: "Tender Support",

  // Service 1 - Registration
  regServiceNum: "Service 01",
  regTitle: "Company Registration",
  regSubtitle: "Market Entry",
  regDesc: "We handle end-to-end incorporation for foreign companies in Rwanda and across East Africa. Our experts navigate local regulations, government bodies, and documentation requirements so you can focus on building your business.",
  regStep1Title: "Initial Consultation",
  regStep1Desc: "We assess your business structure, sector, and target country requirements.",
  regStep2Title: "Document Preparation",
  regStep2Desc: "Our team collects, translates, and notarizes all required incorporation documents.",
  regStep3Title: "Government Filing",
  regStep3Desc: "We file your registration with the Rwanda Development Board (RDB) or relevant authority.",
  regStep4Title: "Tax & Licensing",
  regStep4Desc: "Obtain your TIN, business licenses, and sector-specific permits.",
  regStep5Title: "Bank Account Setup",
  regStep5Desc: "We assist you in opening a local business bank account.",
  regStep6Title: "Operational Launch",
  regStep6Desc: "Company is fully registered and ready to operate legally in-country.",
  regCta: "Start Registration",
  regFormTitle: "Start Your Company Registration",
  regFormName: "Full Name",
  regFormEmail: "Email",
  regFormCountry: "Country of Interest",
  regFormSector: "Sector",
  regFormActivity: "Business Activity",
  regFormSubmit: "Submit Registration Interest",
  regRwandaTitle: "Why Rwanda?",
  regRwandaDesc: "Rwanda ranks #2 in Africa for ease of doing business. 100% foreign ownership, no minimum capital requirement, and digital-first registration make it the top entry point for East Africa.",
  regRwandaStat1: "Avg. Registration",
  regRwandaStat2: "Min. Capital",
  regRwandaStat3: "Foreign Ownership",

  // Service 2 - Compliance
  complianceServiceNum: "Service 02 — Key Differentiator",
  complianceTitle: "Regulatory Compliance",
  complianceSubtitle: "Licensing",
  complianceDesc: "Our regulatory team has deep sector-specific knowledge to get your products registered, licensed, and compliant — fast.",
  complianceItem1: "Medicines & Medical Devices",
  complianceItem1Desc: "Import permits, distribution licenses, pharmacovigilance registration",
  complianceItem2: "Cosmetics & Personal Care",
  complianceItem2Desc: "Product notification, safety assessment, labeling compliance",
  complianceItem3: "Food & Beverages",
  complianceItem3Desc: "FSMS certification, food safety permits, export certifications",
  complianceItem4: "Supplements",
  complianceItem4Desc: "Nutraceutical registration, health claims approval, import clearance",
  complianceItem5: "Household Products",
  complianceItem5Desc: "Chemical registration, safety data sheets, import licensing",
  complianceItem6: "Export & Import Permits",
  complianceItem6Desc: "Trade facilitation, customs classification, documentation support",
  complianceCta: "Request Compliance Support",

  // Service 3 - Investment
  investServiceNum: "Service 03 & 04",
  investTitle: "Investment Facilitation",
  investSubtitle: "Business Expansion",
  investDesc: "Whether you're an international investor or an African company looking to expand, AIP provides the intelligence, connections, and operational support you need to succeed.",
  investService1Title: "FDI Support",
  investService1Desc: "End-to-end support for foreign direct investment — from feasibility studies to operational setup.",
  investService2Title: "Investor-Business Matching",
  investService2Desc: "We connect international investors with pre-vetted local businesses and opportunities.",
  investService3Title: "Market Research",
  investService3Desc: "In-depth market analysis, competitor mapping, and entry strategy for East African markets.",
  investService4Title: "Intra-Africa Expansion",
  investService4Desc: "Support for African companies expanding within the continent — regulatory, legal, and operational.",
  investCardTitle: "Connecting Global Capital",
  investCardDesc: "with East Africa's fastest-growing markets",
  investCta: "Request Service",

  // Service 5 - Tender
  tenderServiceNum: "Service 05 — Niche Expertise",
  tenderTitle: "Tender Support",
  tenderSubtitle: "Services",
  tenderDesc: "Comprehensive tender participation support — from registration to award. We handle the complexity so you can focus on winning.",
  tenderService1Title: "Bidder Registration",
  tenderService1Desc: "Register your company on national and regional tender portals across East Africa.",
  tenderService2Title: "Tender Document Acquisition",
  tenderService2Desc: "We obtain and analyze tender documents on your behalf, ensuring you never miss an opportunity.",
  tenderService3Title: "Bid Securities & Bonds",
  tenderService3Desc: "Sourcing and management of bid bonds and performance guarantees from trusted financial institutions.",
  tenderService4Title: "Bid Preparation",
  tenderService4Desc: "Professional bid writing, technical submissions, and pricing strategy to maximize winning chances.",
  tenderService5Title: "Representation",
  tenderService5Desc: "AIP represents your company at tender openings, clarification meetings, and negotiations.",
  tenderService6Title: "Follow-up & Monitoring",
  tenderService6Desc: "Post-submission monitoring, contract award tracking, and complaint filing if needed.",
  tenderCta1: "Request Tender Support",
  tenderCta2: "View Active Tenders",
  tenderFormTitle: "Submit Tender Support Request",
  tenderFormCompany: "Company Name",
  tenderFormEmail: "Email",
  tenderFormRef: "Tender Reference",
  tenderFormSector: "Sector",
  tenderFormDetails: "Additional Details",
  tenderFormSubmit: "Submit Request",
  tenderFormCancel: "Cancel",
  tenderFormSuccessTitle: "Request Received!",
  tenderFormSuccessBody: "Our tender specialists will contact you within 24 hours.",
};